import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_SE.json';
import exercises from './YOGA_EXERCISES_SE.json';
import recipes from './YOGA_RECIPES_SE.json';

export const YOGA_DATA_SE: ServiceData = {
  articles,
  exercises,
  recipes,
};
